module.exports = __webpack_public_path__ + "static/img/shl.33ba8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl.png
// module id = 8+qz
// module chunks = 0